import AddToCalendarButton from '../util/AddToCalendar'
import { ActivitiesSwiper } from './ActivitiesSwiper'
import ReactGA from 'react-ga4'
export const Main = () => {
    const events = [
        {
            title: "NIS America's Wide World of JRPGs: The Power of Stories",
            startDate: new Date('2024-08-30T14:00:00'),
            endDate: new Date('2024-08-30T15:00:00'),
            description:
                'One of the most appealing aspects of JRPGs are the stories they tell. But what types of JRPG stories are there, and what makes them so good? Join our panel discussion to learn more!',
            location: 'Blue Dragon Theatre, Summit Building',
            timezone: 'America/Los_Angeles',
        },
    ]
    const merchdata = [
        {
            name: 'Falcom Plush Bundle 1',
            game: 'YsX: Nordics',
            img: 'Falcom-Plush-Bundle-1',
            price: 74.98,
            lmd: true,
        },
        {
            name: 'Falcom Plush Bundle 2',
            game: 'Trails through Daybreak',
            img: 'Falcom-Plush-Bundle-2',
            price: 74.98,
            lmd: true,
        },

        {
            name: 'Falcom Acrylic Bundle 1',
            game: 'Ys X: Nordics',
            img: 'Falcom-Acrylic-Bundle-1',
            price: 24.98,
            lmd: true,
        },
        {
            name: 'Falcom Acrylic Bundle 2',
            game: 'Trails through Daybreak',
            img: 'Falcom-Acrylic-Bundle-2',
            price: 24.98,
            lmd: true,
        },
        {
            name: 'Prinny Plush Bundle',
            game: 'NIS',
            img: 'Prinny-Plush-Bundle',
            price: 84.97,
            lmd: true,
        },
        {
            name: 'Phantom Brave Plush Bundle',
            game: 'Phantom Brave: The Lost Hero',
            img: 'Phantom-Brave-Plush-Bundle',
            price: 94.97,
            lmd: true,
        },
        {
            name: 'Disgaea 1 Plush Bundle',
            game: 'Disgaea 1',
            img: 'Disgaea-Lil-Plush-Bundle-Front',
            price: 90.97,
            lmd: true,
        },
        {
            name: 'Decal Bundle',
            game: 'NIS',
            img: 'Decal-Bundle',
            price: 15.97,
            lmd: true,
        },
        {
            name: 'Prinny 2024 T-Shirt',
            game: 'NIS',
            img: 'Prinny-2024-T-Shirt',
            price: 29.99,
            lmd: false,
        },
        {
            name: 'Pocket Sized Hero Prinny',
            game: 'NIS',
            img: 'Pocket-Sized-Hero-Prinny',
            price: 19.99,
            lmd: false,
        },
        {
            name: 'Prinny Wearable Towel',
            game: 'NIS',
            img: 'Prinny-Wearable-Towel',
            price: 39.99,
            lmd: false,
        },
        {
            name: 'Fuka Newsie Cap',
            game: 'NIS',
            img: 'Fuka-Newsie-Cap',
            price: 39.99,
            lmd: false,
        },
    ]

    return (
        <div className='max-w-[1000px] mx-auto text-center'>
            <div className='bg-stripe pb-8 px-4 lg:px-8'>
                <section id='booth'>
                    <div className='flex justify-center mt-12'>
                        <img
                            className='text-center'
                            src={`${process.env.PUBLIC_URL}/images/title-booth.webp`}
                            alt='booth'
                        />
                    </div>
                    <div className='lg:px-8 md:py-12'>
                        {' '}
                        <div className='flex justify-center mt-12'>
                            <img
                                className='text-center'
                                src={`${process.env.PUBLIC_URL}/images/map.webp`}
                                alt='booth'
                            />
                        </div>{' '}
                        <div className='border-2 md:border-none border-gray-400 bg-white flex flex-col md:flex-row justify-evenly items-center text-left my-12 text-body md:py-4 shadow-sm'>
                            <div className='text-center md:text-left md:px-2 lg:px-8 w-full md:w-auto md:border-none py-2'>
                                <div className='uppercase text-subsmall text-gray-400 tracking-wider'>
                                    <p>Booth Hours</p>
                                </div>
                                <div className='text-sm md:text-md font-black text-shadow-whitestroke'>
                                    <p>10:00 am ~ 6:00 pm</p>
                                </div>
                            </div>{' '}
                            <div className='text-center md:text-left md:px-2 lg:px-8 border-t-2 border-gray-400 w-full md:w-auto md:border-none py-2'>
                                <div className='uppercase text-subsmall text-gray-400 tracking-wider'>
                                    <p>Booth Location</p>
                                </div>
                                <div className='text-sm md:text-md font-black'>
                                    <p>Arch Expo Hall, Booth 1713</p>
                                </div>
                            </div>{' '}
                        </div>{' '}
                    </div>{' '}
                </section>{' '}
                <section id='panel'>
                    <div className='flex justify-center mb-8'>
                        <img
                            className='text-center '
                            src={`${process.env.PUBLIC_URL}/images/title-panel.webp`}
                            alt='panel'
                        />
                    </div>
                    <div className='lg:px-8'>
                        <div>
                            <div className=' mx-auto '>
                                <h1 className='text-body font-black text-md md:text-lg mt-12 mb-4 text-center'>
                                    NIS America's Wide World of JRPGs:{' '}
                                    <span className='whitespace-nowrap'>The Power of Stories</span>
                                </h1>
                                <p className='text-body text-center mt-4'>
                                    One of the most appealing aspects of JRPGs are the stories they tell. But what types
                                    of JRPG stories are there, and what makes them so good? Join our panel discussion to
                                    learn more!
                                </p>
                            </div>
                            <div className='pt-2 md:pt-8'>
                                <div className='flex flex-row space-x-4 justify-center text-center align-middle my-8 items-center  mx-auto'>
                                    <div className='w-full border-t border-gray-400' />
                                    <div className='text-sm text-center  whitespace-nowrap mx-auto uppercase text-navy tracking-wider font-bold'>
                                        <h2> Panelists</h2>
                                    </div>{' '}
                                    <div className='w-full border-t border-gray-400' />
                                </div>
                                {/* <h2 className='text-body text-sm text-center mt-8 mb-4'>Panelists</h2> */}
                                <div className='flex flex-row justify-center space-x-4 mx-auto '>
                                    <div>
                                        {' '}
                                        <img
                                            className='rounded-full border-white border-4 shadow-sm'
                                            src={`${process.env.PUBLIC_URL}/images/davidinc.webp`}
                                            alt='Davidvinc RPGs'
                                        />
                                        <h3 className='text-body text-center mt-2 font-black'>Davidvinc RPGs</h3>
                                    </div>{' '}
                                    <div>
                                        {' '}
                                        <img
                                            className='rounded-full border-white border-4 shadow-sm'
                                            src={`${process.env.PUBLIC_URL}/images/justthegems.webp`}
                                            alt='Just the Gems'
                                        />{' '}
                                        <h3 className='text-body text-center mt-2 font-black'>Just the Gems</h3>
                                    </div>{' '}
                                    <div>
                                        <img
                                            className='rounded-full border-white border-4 shadow-sm'
                                            src={`${process.env.PUBLIC_URL}/images/cameronH.webp`}
                                            alt='Cameron Hawkins'
                                        />{' '}
                                        <h3 className='text-body text-center mt-2 font-black'>Cameron Hawkins</h3>
                                    </div>{' '}
                                </div>{' '}
                            </div>
                            <div className='border-2 md:border-none border-gray-400 bg-white flex flex-col md:flex-row justify-evenly items-center text-left my-12 text-body md:py-4 shadow-sm'>
                                <div className='text-center md:text-left md:px-2 lg:px-2 w-full md:w-auto md:border-none py-2'>
                                    <div className='uppercase text-subsmall text-gray-400 tracking-wider'>
                                        <p>Date</p>
                                    </div>
                                    <div className='text-sm md:text-baseMd font-black text-shadow-whitestroke'>
                                        <p>8/30</p>
                                    </div>
                                </div>{' '}
                                <div className='text-center md:text-left md:px-2 lg:px-2 border-t-2 border-gray-400 w-full md:w-auto md:border-none py-2'>
                                    <div className='uppercase text-subsmall text-gray-400 tracking-wider'>
                                        <p>Time</p>
                                    </div>
                                    <div className='text-sm md:text-baseMd font-black'>
                                        <p>2:00 PM~</p>
                                    </div>
                                </div>{' '}
                                <div className='text-center md:text-left md:px-2 lg:px-2 border-t-2 border-gray-400 w-full md:w-auto md:border-none py-2'>
                                    <div className='uppercase text-subsmall text-gray-400 tracking-wider'>
                                        <p>Room</p>
                                    </div>
                                    <div className='text-sm md:text-baseMd font-black'>
                                        <p>Blue Dragon Theatre, Summit Building</p>
                                    </div>
                                </div>{' '}
                            </div>{' '}
                            <div className='flex flex-col md:flex-row justify-center gap-4'>
                                <div>
                                    <button className='min-w-[300px] md:min-w-none font-sans font-bold hover:brightness-125 hover:scale-105 duration-200 bg-cyan-500 text-white border-double border-4 border-white inline-block py-4 text-center px-4 md:px-20 shadow-md '>
                                        <a
                                            onClick={() => {
                                                ReactGA.event({
                                                    action: 'click',
                                                    event: 'link',
                                                    category: 'Event',
                                                    label: `Pax livestream`,
                                                })
                                            }}
                                            aria-label='Pax Livestream'
                                            target='_blank'
                                            rel='noreferrer'
                                            data-label='Pax Livestream'
                                            href='https://m.twitch.tv/pax2'
                                        >
                                            {' '}
                                            Watch the Livestream
                                        </a>
                                    </button>
                                </div>{' '}
                                <div>
                                    <AddToCalendarButton event={events[0]} />
                                </div>{' '}
                            </div>{' '}
                        </div>
                    </div>
                </section>{' '}
                <section id='demos'>
                    <div className='flex justify-center pt-12 my-12'>
                        <img
                            className='text-center '
                            src={`${process.env.PUBLIC_URL}/images/title-demos.webp`}
                            alt='demo'
                        />
                    </div>{' '}
                    <div className='lg:px-8 pb-12'>
                        <h3 className='text-body'>
                            Be one of the first players in North America to try our upcoming titles!
                        </h3>
                        <div className='flex flex-wrap gap-4 justify-between mt-12'>
                            <div className='w-[47%] md:w-[48%]'>
                                <a href='https://www.nisamerica.com/ys-x/'>
                                    <img
                                        className='w-full hover:brightness-125 duration-300 cursor-pointer'
                                        src={`${process.env.PUBLIC_URL}/images/demo/demo-ysx-2.jpg`}
                                        alt='demo ys'
                                    />{' '}
                                </a>
                            </div>
                            <div className='w-[47%] md:w-[48%]'>
                                <a href='https://www.nisamerica.com/reynatis'>
                                    <img
                                        className='hover:brightness-125 duration-300 cursor-pointer'
                                        src={`${process.env.PUBLIC_URL}/images/demo/demo-reynatis-2.jpg`}
                                        alt='demo reynatis'
                                    />{' '}
                                </a>
                            </div>
                            <div className='w-[47%] md:w-[48%]'>
                                {' '}
                                <a href='https://thelegendofheroes.com/daybreak2/'>
                                    <img
                                        className='hover:brightness-125 duration-300 cursor-pointer'
                                        src={`${process.env.PUBLIC_URL}/images/demo/demo-daybreak-2.jpg`}
                                        alt='demo daybreak2'
                                    />{' '}
                                </a>
                            </div>
                            <div className='w-[47%] md:w-[48%]'>
                                {' '}
                                <a href='https://nisamerica.com/phantombrave-the-lost-hero'>
                                    <img
                                        className='hover:brightness-125 duration-300 cursor-pointer'
                                        src={`${process.env.PUBLIC_URL}/images/demo/demo-pb2-2.jpg`}
                                        alt='demo phantom brave the lost hero'
                                    />{' '}
                                </a>
                            </div>
                        </div>{' '}
                    </div>{' '}
                </section>{' '}
                <section id='activities'>
                    <div className='flex justify-center my-8 pt-12'>
                        <img
                            className='text-center '
                            src={`${process.env.PUBLIC_URL}/images/title-activities.webp`}
                            alt='activities'
                        />
                    </div>
                    <div className='lg:px-8 flex items-center justify-center flex-col py-2 md:py-8 gap-4 mx-auto'>
                        <ActivitiesSwiper />{' '}
                    </div>{' '}
                </section>{' '}
                <section id='merch' className='mt-12'>
                    <div className='flex justify-center pt-8 pb-12'>
                        <img
                            className='text-center '
                            src={`${process.env.PUBLIC_URL}/images/title-merchandise.webp`}
                            alt='merchandise'
                        />
                    </div>{' '}
                    <div className='font-bold pb-12 lg:px-8'>
                        <h3 className='text-body'>Stop by our booth to stock up on some awesome NIS America merch!</h3>
                        <swiper-container
                            navigation='false'
                            pagination='false'
                            loop='true'
                            autoplay='true'
                            autoHeight='true'
                            breakpoints={JSON.stringify({
                                280: {
                                    slidesPerView: 1.6,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 1.6,
                                    spaceBetween: 10,
                                },
                                820: {
                                    slidesPerView: 1.8,
                                    spaceBetween: 10,
                                },
                                1024: {
                                    slidesPerView: 2.4,
                                    spaceBetween: 10,
                                },
                            })}
                        >
                            {merchdata.map((item, i) => (
                                <>
                                    <swiper-slide key={i}>
                                        <div className='flex flex-col justify-between bg-white rounded-md shadow-md mt-8 min-h-[380px] md:min-h-[500px]'>
                                            <div className='relative '>
                                                <img
                                                    key={i}
                                                    className='p-8'
                                                    src={`${process.env.PUBLIC_URL}/images/merch/${item.img}.webp`}
                                                    alt={item.name}
                                                />
                                            </div>
                                            <div className='px-2 md:px-4 mt-4 bg-blue-200 '>
                                                <a
                                                    onClick={() => {
                                                        ReactGA.event({
                                                            action: 'click',
                                                            event: 'link',
                                                            category: 'Merchandise',
                                                            label: item.name,
                                                        })
                                                    }}
                                                    href={item.link}
                                                >
                                                    <p className='text-left text-subsmall mt-4 text-gray-500 uppercase font-bold'>
                                                        {item.game}
                                                    </p>
                                                </a>
                                            </div>
                                            <div className='bg-blue-200 text-sub md:text-md text-body font-black  px-2 md:px-4 pt-2 grow'>
                                                <a
                                                    onClick={() => {
                                                        ReactGA.event({
                                                            action: 'click',
                                                            event: 'link',
                                                            category: 'Merchandise',
                                                            label: item.name,
                                                        })
                                                    }}
                                                    href={item.link}
                                                >
                                                    <p className='text-left'>{item.name}</p>
                                                </a>
                                            </div>
                                            <div className='bg-blue-200 pb-4 px-2 md:px-4 rounded-b-md'>
                                                <a
                                                    onClick={() => {
                                                        ReactGA.event({
                                                            action: 'click',
                                                            event: 'link',
                                                            category: 'Merchandise',
                                                            label: item.name,
                                                        })
                                                    }}
                                                    href={item.link}
                                                >
                                                    <p className='text-sm my-auto font-bold text-right text-body'>
                                                        $ {item.price}
                                                    </p>
                                                </a>
                                            </div>{' '}
                                        </div>
                                    </swiper-slide>
                                </>
                            ))}
                        </swiper-container>{' '}
                    </div>{' '}
                </section>
            </div>{' '}
        </div>
    )
}
